
import { SubscriptionTier } from "./useSubscriptionUpdate";

interface PricingTierData {
  name: string;
  description: string;
  price: number;
  features: string[];
  tier: SubscriptionTier;
  gradientFrom: string;
  gradientTo: string;
}

export const PRICING_TIERS: PricingTierData[] = [
  {
    name: "Free",
    description: "Perfect to get started",
    price: 0,
    features: [
      "5 resources per month",
      "Basic analytics",
      "Community support"
    ],
    tier: "free",
    gradientFrom: "pink-600",
    gradientTo: "purple-600"
  },
  {
    name: "Basic",
    description: "For growing teams",
    price: 100,
    features: [
      "10 resources per month",
      "Advanced analytics",
      "Priority email support"
    ],
    tier: "basic",
    gradientFrom: "blue-600",
    gradientTo: "cyan-600"
  },
  {
    name: "Growth",
    description: "For scaling businesses",
    price: 250,
    features: [
      "20 resources per month",
      "Custom analytics",
      "24/7 phone support"
    ],
    tier: "growth",
    gradientFrom: "purple-600",
    gradientTo: "indigo-600"
  },
  {
    name: "Professional",
    description: "For large enterprises",
    price: 500,
    features: [
      "40 resources per month",
      "AI-powered insights",
      "Dedicated account manager"
    ],
    tier: "professional",
    gradientFrom: "amber-600",
    gradientTo: "orange-600"
  }
];
